import { createFileRoute, Navigate, Outlet } from "@tanstack/react-router";
import { Headphones } from "lucide-react";
import { useCurrentTenant } from "@/hooks/use-session";

export const Route = createFileRoute("/_app/call-center")({
  staticData: {
    title: "Call Center",
    breadcrumb: "Call Center",
    breadcrumbIcon: Headphones,
    breadcrumbLink: false,
  },
  component: CallCenterLayout,
});

function CallCenterLayout() {
  const tenant = useCurrentTenant();

  if (!tenant.modules?.includes("call_center")) {
    return <Navigate to="/" />;
  }

  return <Outlet />;
}
